<script>
import FormModel from "@/views/Request/Claim/Components/FormModel.vue";

export default {
    name: "AdminRequestForm",
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        deleteAction: Boolean,
        viewAction: Boolean,
        intranet: Boolean
    },
    components: {FormModel}
}
</script>

<template>
        <form-model
            type="ADMIN_REQUEST"
            :view-action="viewAction"
            :delete-action="deleteAction"
            :add-action="addAction"
            :update-action="updateAction"
            :intranet="intranet"
        />
</template>